export const handleChangeDataEditOrderPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_EDIT_ORDER', name, value
});